<template>
  <BookForm
    :params="params"
    :result="result"
    :category="category"
    :meal="meal"
    @back="onBack"
    @book="onBook"
    />
</template>

<script>
import model from './services/model'
import { getHotelInfo } from 'b2b-common/services/api/hotel'
import BookForm from './components/book_form'

export default {
  components: { BookForm },
  async created () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())

    if (result.hotelInfo) return

    const hotelInfo = await getHotelInfo({ hotelId: result.id })

    this.$set(result, 'hotelInfo', hotelInfo[0])
  },
  data () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())
    const category = result.categories.find(el => el.id.toString() === routeParams.Category.toString())
    const meal = category.meals[routeParams.Meal]

    return {
      params: model.params,
      result,
      category,
      meal
    }
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Private/Hotel/Search' })
    },
    onBook (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  }
}
</script>
